/**
 * Maps country codes to their default currencies
 */
const COUNTRY_CURRENCY_MAP: Record<string, string> = {
  // Euro countries
  'DE': 'EUR', // Germany
  'FR': 'EUR', // France
  'ES': 'EUR', // Spain
  'IT': 'EUR', // Italy
  'NL': 'EUR', // Netherlands
  'BE': 'EUR', // Belgium
  'IE': 'EUR', // Ireland
  'PT': 'EUR', // Portugal
  'GR': 'EUR', // Greece
  'AT': 'EUR', // Austria
  'FI': 'EUR', // Finland
  'SK': 'EUR', // Slovakia
  'SI': 'EUR', // Slovenia
  'CY': 'EUR', // Cyprus
  'EE': 'EUR', // Estonia
  'LV': 'EUR', // Latvia
  'LT': 'EUR', // Lithuania
  'LU': 'EUR', // Luxembourg
  'MT': 'EUR', // Malta

  // Other major currencies
  'GB': 'GBP', // United Kingdom
  'CA': 'CAD', // Canada
};

type Currency = 'EUR' | 'USD' | 'GBP' | 'CAD' | 'GEN';

/**
 * Gets the default currency based on the user's browser locale
 * Falls back to USD if the country is not mapped or locale cannot be determined
 */
export function getDefaultCurrency(): Currency {
  try {
    const locale = navigator.language;
    const countryCode = locale.split('-')[1]?.toUpperCase() || locale.toUpperCase();
    const currency = COUNTRY_CURRENCY_MAP[countryCode] || 'USD';
    return currency as Currency;
  } catch (error) {
    console.warn('Failed to detect locale, defaulting to USD:', error);
    return 'USD';
  }
}

/**
 * Gets the country code from the user's browser locale
 * Returns null if the locale cannot be determined
 */
export function getCountryCode(): string | null {
  try {
    const locale = navigator.language;
    return locale.split('-')[1]?.toUpperCase() || null;
  } catch (error) {
    console.warn('Failed to detect country code:', error);
    return null;
  }
} 